module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/join-option-online-e1c9497ab08ba9389b96764af55b617b.jpg";